import { __awaiter, __generator } from "tslib";
import { logger } from '../logger';
export var isValidEmail = function (email) {
    var re = 
    /* eslint-disable-next-line no-useless-escape */
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
};
/**
 * @description SHA-1 is a cryptographic hash function which takes an input and produces a 160-bit hash value known as a message digest – typically rendered as a hexadecimal number, 40 digits long.
 * @param input A string to hash
 */
export var sha1 = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var subtle, characters, bytes, algo, hashedInput, _a, _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                subtle = crypto.subtle;
                characters = input.split('');
                bytes = new Uint8Array(input.length).map(function (_, index) {
                    return characters[index].charCodeAt(0);
                });
                algo = atob('U0hBLTE') // base64 of "SHA-1"
                ;
                _b = (_a = Array).from;
                _c = Uint8Array.bind;
                return [4 /*yield*/, subtle.digest(algo, bytes)];
            case 1:
                hashedInput = _b.apply(_a, [new (_c.apply(Uint8Array, [void 0, _d.sent()]))()])
                    .map(function (int) { return ('00' + int.toString(16)).slice(-2); })
                    .join('');
                logger.debug("Input hashed into ".concat(hashedInput));
                return [2 /*return*/, hashedInput];
        }
    });
}); };
export var getHashOrNull = function (shouldHash, value) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!shouldHash) return [3 /*break*/, 2];
                return [4 /*yield*/, sha1(value)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2: return [2 /*return*/, null];
        }
    });
}); };
var HAS_IDENTIFIED_KEY = 'dd_has_identified';
/**
 * @description If `email` is found in analytics but no `id`, identify the user with that email.
 * @param shouldHash Boolean value that controls if a `sha1 digest` of the email is going to be used as an `id`
 */
export var identifyFromEmail = function (analytics, shouldHash) { return __awaiter(void 0, void 0, void 0, function () {
    var anonymousId, id, email, isEmail, userId;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                anonymousId = analytics.user().anonymousId();
                // Skip if we have already identified user with same anonymous id
                if (localStorage.getItem(HAS_IDENTIFIED_KEY) === anonymousId) {
                    return [2 /*return*/];
                }
                id = analytics.user().id();
                if (id) {
                    return [2 /*return*/];
                }
                email = (_a = analytics.user().traits()) === null || _a === void 0 ? void 0 : _a.email;
                isEmail = email && isValidEmail(email);
                if (!isEmail) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, getHashOrNull(shouldHash, email)];
            case 1:
                userId = _b.sent();
                logger.debug('Identifying user from stored email due to missing id', {
                    email: email,
                    userId: userId,
                });
                // Identify cannot run before `analytics` has been properly initialized
                // or env enrichment (like setting library version) will not work
                /* eslint-disable-next-line @typescript-eslint/no-floating-promises */
                analytics.ready(function () {
                    return analytics.identify(userId, { email: email }).catch(function (error) {
                        logger.error('Failed to identify user from existing data');
                        logger.debugError(error);
                    });
                });
                if (anonymousId) {
                    localStorage.setItem(HAS_IDENTIFIED_KEY, anonymousId);
                }
                return [2 /*return*/];
        }
    });
}); };
export var getEmail = function (elements) {
    var inputs = (Array.isArray(elements) ? elements : Array.from(elements));
    var emailInput = inputs.find(function (element) {
        return isValidEmail(element.value);
    });
    return emailInput === null || emailInput === void 0 ? void 0 : emailInput.value;
};
/**
 * Determines the name to use for tracking form submissions.
 *
 * This function selects the track name based on provided options. If `eventName` is specified in the options,
 * it takes precedence. Otherwise, if `useFormNameAsEventName or useFormIdAsEventName` is true, the function attempts to use the form's `name` or `id` attribute.
 * Fallbacks to a default name if no name is found or specific conditions are not met.
 *
 * @param {HTMLFormElement} $form - The form element from which to derive the tracking name
 * @param {IAutoIdentifyOptions} options - Configuration options that influence the track name selection.
 * @returns {string} The determined track name for the form submission event.
 */
export var getEventName = function ($form, options) {
    var defaultName = 'form-submit';
    if (options.eventName) {
        return options.eventName;
    }
    if (options.useFormIdAsEventName) {
        var formNameFromIdAttribute = $form.getAttribute('id');
        if (!formNameFromIdAttribute) {
            logger.error("'useFormIdAsEventName' is set to true but the form is missing an 'id' attribute. Defaulting back to name '".concat(defaultName, "'"));
            return defaultName;
        }
        return formNameFromIdAttribute;
    }
    if (options.useFormNameAsEventName) {
        var formNameFromNameAttribute = $form.getAttribute('name');
        if (!formNameFromNameAttribute) {
            logger.error("'useFormNameAsEventName' is set to true but the form is missing a 'name' attribute. Defaulting back to name '".concat(defaultName, "'"));
            return defaultName;
        }
        return formNameFromNameAttribute;
    }
    return defaultName;
};
export function eventIsTrusted(event) {
    return event.isTrusted;
}
//# sourceMappingURL=utils.js.map